<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-alert variant="warning"
                   dismissible
                   :show="browserMsg.length > 0"
                   @dismissed="showDismissibleAlert=false">
            {{ browserMsg }}
          </b-alert>
          <b-card-group>
            <b-card no-body class="p-4" v-on:keyup.enter="login">
              <b-card-body>
                <h1>Login</h1>
                <b-alert :variant="dismissibleType"
                         dismissible
                         :show="showDismissibleAlert"
                         @dismissed="showDismissibleAlert=false">
                  {{ errMsg }}
                </b-alert>
                <b-row>
                  <b-col cols="12">
                    <ul class="text-danger" style="list-style: none;" v-for="err in validateErrors.items" :key="err.id">
                      <li><strong class="text-danger">{{ err.msg }}</strong></li>
                    </ul>
                    <!--<b-list-group style="min-width:100%">
                      <b-list-group-item class="py-2" v-for="err in validateErrors.items" :key="err.id">
                        <strong class="text-danger">
                          {{ err.msg }}
                        </strong>
                      </b-list-group-item>
                    </b-list-group>-->
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">

                    <p v-if="validateErrors.items.length === 0" class="text-muted">Sign In to your account</p>

                    <b-input-group class="mb-3">
                      <b-input-group-prepend><b-input-group-text><i class="icon-folder"></i></b-input-group-text></b-input-group-prepend>
                      <input name="Account number" v-validate="{required: true, min: 1, max: 40}" v-model.trim="loginInfo.account" type="text" class="form-control" placeholder="Account#">
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                      <input name="Username" v-validate="{required: true, min: 1, max: 40}" v-model.trim="loginInfo.login" type="text" class="form-control" placeholder="Username">
                    </b-input-group>
                    <b-input-group class="mb-4">
                      <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                      <input name="Password" v-validate="{required: true, min: 1, max: 40}" v-model.trim="loginInfo.password" type="password" class="form-control" placeholder="Password">
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="primary" @click="login" class="px-4">Login</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import loading from 'vue-full-loading'
  import Router from '@/router'
  import Store from '@/store'
  import VueCookies from 'vue-cookies'
  import tokenexpiration from '@/shared/tokenexpiration'

  Vue.use(VueCookies)

  export default {
    name: 'login',
    components: {
      loading
    },
    created() {
      if (tokenexpiration.checkCookieExpiredInLogin(this)) {
        this.errMsg = 'Sorry, your session has timed out because of inactivity. Please sign in again.'
        this.showDismissibleAlert = true
        this.dismissibleType = 'warning'
      }

      var ua = window.navigator.userAgent
      // IE 11
      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        var rv = ua.indexOf('rv:')
        if (rv > 0) {
          // var ie11 = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
          this.browserMsg = 'You may have a better experience with another browser like Chrome or Firefox.'
        }
      }
    },
    data() {
      return {
        browserMsg: '',
        errMsg: '',
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        boolLoading: false,
        txtLoading: 'Loading...',
        loginInfo: {
          account: '',
          login: '',
          password: ''
        }
      }
    },
    beforeCreate() {
      if (this.$cookies.isKey('.jwt') && !Store.state.passwordChangeRequired) {
        Router.push('/')
      }
    },
    methods: {
      login() {
        var self = this

        self.$validator.validateAll().then((result) => {
          if (result) {
            self.boolLoading = true
            axios.post('/auth/authorize', this.loginInfo)
              .then(response => {
                this.boolLoading = false

                //Catch custom error thrown. Ex: Invalid login credentials
                if (typeof (response.data.error_message) != "undefined" && response.data.error_message !== '') {
                  self.errMsg = response.data.error_message
                  self.showDismissibleAlert = true
                }
                else {
                  localStorage.setItem('login', this.loginInfo.login)
                  localStorage.setItem('account', this.loginInfo.account)
                  localStorage.setItem('partner_id_int', response.data.partner_id_int)

                  Store.commit('LOGIN_USER')
                  Store.commit('PASSWORD_CHANGE_REQUIRED', response.data.isbackdoor ? false : response.data.password_change_requested)
                  Store.state.isInternalStaff = response.data.isInternalStaff

                  if (response.data.user_id !== undefined && parseInt(response.data.user_id) === 1) {
                    Store.commit('ROLE_SETUP', 'Admin')
                  } else {
                    Store.commit('ROLE_SETUP', 'User')
                  }

                  if (response.data.password_change_requested) {
                    Router.push('/MyProfile/1')
                  } else {
                    Router.push('/')
                  }
                }
              })
              .catch(error => {
                self.boolLoading = false
                //Http/2 protocol does not support statustext. It defaults to ""
                self.errMsg = error.response.data.error_message
                self.showDismissibleAlert = true
              })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/auth/Login.vue